import { createRouter, createWebHistory } from 'vue-router';
import AccountDeletion from '../components/AccountDeletion.vue';


const routes = [
  {
    path: '/',
    name: 'AccountDeletion',
    component: AccountDeletion
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;